import { createContext } from 'react';
var ApiContext = createContext({ apiBaseUrl: '' });
export default ApiContext;
